export default [
    {
        path: 'violacaodedireitos/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'ViolenciaViolacaoDireitoController' }
    },
    {
        path: 'violacaodedireitos/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'ViolenciaViolacaoDireitoController' },
    },
    {
        path: 'violacaodedireitos/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'ViolenciaViolacaoDireitoController'
        }
    },
    {
        path: 'relatorios/violacaodedireitos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/violacaodedireitos/home',
        meta: { middleware: 'auth', controller: 'RelatorioViolenciaViolacaoDireitoController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_vvd',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioViolenciaViolacaoDireitoController' },
        }, {
            path: 'graficos',
            name: 'graficos_vvd',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioViolenciaViolacaoDireitoController' },
        }
        ]
    }
]
